export default __webpack_public_path__ + "static/media/ReportIcon-Bandage-MS.391845e6.jpg";